import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Components.css';

class Footer extends Component {
    
    render() { 
        return ( 
            <div className="footer-copyright bg-dark text-center text-white">
                <p className="py-3 mb-0">
                    Copyright &copy; 2020 | Phanindra Reddy
                </p>
            </div>
         );
    }
}
 
export default Footer;